import { render, staticRenderFns } from "./BidDetailInfo.vue?vue&type=template&id=7a9f5c10&scoped=true&"
import script from "./BidDetailInfo.vue?vue&type=script&lang=js&"
export * from "./BidDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./BidDetailInfo.vue?vue&type=style&index=0&id=7a9f5c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9f5c10",
  null
  
)

export default component.exports